// Single source of truth for backend base URL.
// Prefer runtime window.env (e.g. from env.js) then build-time REACT_APP_API_URL,
// and finally fall back to legacy process.env.API_URL if present.
export function getBaseUrl() {
  const fromWindow =
    typeof window !== "undefined" &&
    window.env &&
    typeof window.env.API_URL === "string" &&
    window.env.API_URL;

  const fromReactApp = process.env.REACT_APP_API_URL;
  const fromLegacy = process.env.API_URL;

  return fromWindow || fromReactApp || fromLegacy || "";
}

